<template>
  <div class="solution dropdown-item">
    <a
      :href="appLinkItem.url"
      :target="isDirectApp() ? 'direct-apps' : 'direct-home'"
      :rel="!isDirectApp() ? 'noopener' : undefined"
    >
      <div class="image">
        <img :src="iconUrl()" :alt="appLinkItem.name" @error="onLoadingError" />
      </div>
      <div class="name" v-text="appLinkItem.name" />
    </a>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, type PropType } from "vue";
import { isDirectAppsUrl } from "../url/links";
import type { AppLinkItem } from "./types";

export default defineComponent({
  name: "navbar-menu-solution-item-class",
  props: {
    appLinkItem: {
      type: Object as PropType<AppLinkItem>,
      // NOTE: 旧コードの default は `() => []`（Object prop に配列）で型不正だった。
      // 親は常に値を渡すため default は実質未使用だが、型に合う空オブジェクトに正す。
      default: (): AppLinkItem => ({ url: "", iconUrl: "", name: "" }),
    },
    domainId: { type: String, default: () => "" },
  },
  setup(props) {
    const hasLoadingError = ref(false);

    const onLoadingError = (): void => {
      hasLoadingError.value = true;
    };

    const iconUrl = (): string =>
      hasLoadingError.value
        ? `/assets/images/solutions/app_icon_noload.svg`
        : props.appLinkItem.iconUrl;

    const isDirectApp = (): boolean => isDirectAppsUrl(props.appLinkItem.url);

    return {
      hasLoadingError,
      onLoadingError,
      iconUrl,
      isDirectApp,
    };
  },
});
</script>

<style scoped lang="scss">
// 詳細度調整
.solution {
  display: inline-block;
  width: 70px;
  height: 80px;
  padding: 0px;

  &:hover,
  &:focus,
  &:active {
    border-radius: 8px;
    background-color: #e9ecef;
  }

  > a {
    display: block;
    padding: 6px 6px 0px 6px;
    margin: 0px;
    border: none;
    text-align: center;
    font-size: small;
    text-decoration: none;

    .image {
      > img {
        height: 50px;
        width: 50px;
      }
    }

    .name {
      margin-top: 4px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: black;
      font-size: 10px;
    }

    &:hover,
    &:focus,
    &:active {
      color: #333333;
      border-radius: 8px;
    }
  }
}
</style>
